import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import Verkoop from './pages/verkoop/Verkoop';
import Afrekenen from './pages/afrekenen/Afrekenen';
import Winkelwagen from './pages/winkelwagen/Winkelwagen';
import Confirmatie from './pages/confirmatie/Confirmatie';
import './App.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode><Router>
                <Routes>
                <Route path="" element={<Verkoop />} />
                <Route path="/winkelwagen" element={<Winkelwagen />} />
                <Route path="/afrekenen" element={<Afrekenen />} />
                <Route path="/confirmatie" element={<Confirmatie />} />
            </Routes>
        </Router>,

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
